<template>
    <div v-if="stylesApplied" class="style-wrapper">
        <el-tooltip placement="top"
                    :content="styleTooltip"
                    :show-after="10">
            <div class="bedge">
                <div class="lock" />
                <div v-if="showStyleName" class="style-text">
                    {{ styleName }}
                </div>
            </div>
        </el-tooltip>
    </div>
</template>

<script lang="ts">
    import { useI18n } from 'vue-i18n'
    import { defineComponent } from 'vue';
    import { segmentsStore } from '@/stores/segmentsStore';

    export default defineComponent({
        name: 'StyleBadge',
        props: {
            stylesApplied: {
                type: Boolean,
                required: true
            },
            styleName: {
                type: String,
                default: ''
            },
        },
        setup() {
            const { t } = useI18n()
            return { t }
        },
        data() {
            return {
                segmentsStore: segmentsStore(),
            };
        },
        computed: {
            showStyleName(): boolean {
                return this.segmentsStore.translationConfiguration?.showParagraphStyle ?? false;
            },
            styleTooltip(): string {
                return this.t('translationSegment.paragraphStyleInfo', [this.styleName]);
            },
        },
    });
</script>

<style lang="scss" scoped>
    .style-wrapper {
        position: relative;

        .bedge {
            position: absolute;
            top: -20px;
            left: -20px;
            padding: 5px 12px;
            background-color: var(--style-bedge);
            border-radius: 20px;
            display: flex;
            align-items: center;
            user-select: none;
        }

        .style-text {
            color: var(--white);
            white-space: nowrap;
            font-size: 14px;
            margin-left: 5px;
        }

        .lock {
            background-image: url("@/images/lock.svg");
            background-size: 20px;
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
        }
    }
</style>